<app-side-menu [(isExpanded)]="isExpanded" >
	<app-side-menu-title>
		{{"Dokument" | translate : "label-document"}}
	</app-side-menu-title>
	<app-side-menu-content>
		<app-side-menu-group>
			<app-side-menu-group-title>
				{{"Firmenanmeldung" | translate : "label-company-registration"}}
			</app-side-menu-group-title>
			<app-side-menu-group-content>
				@let selectableDocuments = selectableCustomerDocuments();
				@let isDisabled = selectableDocuments.length === 0;
			
				<form [formGroup]="form" (submit)="submit()">
					<mat-form-field>
						<mat-label class="mat-body-large">{{"Dokument" | translate : "input-document"}}</mat-label>
						<input matInput
							formControlName="document"
							[matAutocompleteDisabled]="isDisabled"
							[matAutocomplete]="auto"/>
							<mat-autocomplete #auto="matAutocomplete" class="select__panel--surface"
							[displayWith]="formatDocumentForTrigger"
							(optionSelected)="selectDocument($event.option.value)">
								@for(document of selectableDocuments; track document.id){
									<mat-option [value]="document.id">
										{{document.name}}
									</mat-option>
								}
						</mat-autocomplete>
			 </mat-form-field>
				@let selected = selectedDocument();				
				<mat-form-field>
					<mat-label class="mat-body-large">{{"Gültigkeit" | translate : "input-validity"}}</mat-label>
					<input matInput 
											 [value]="selectedDocumentDuration()" 
												[disabled]="true"/>
			 </mat-form-field>
				<mat-form-field>
					<mat-label class="mat-body-large">{{"Anmerkung" | translate : "input-note"}}</mat-label>
						<textarea matInput
										cdkTextareaAutosize
										#autosize="cdkTextareaAutosize"
										cdkAutosizeMinRows="1"
										cdkAutosizeMaxRows="3"
										[value]="selected?.description ?? ''"
										[disabled]="true"></textarea>
			 </mat-form-field>
				<section class="project-documents-menu__operators">
						<button mat-button class="button--tertiary" type="submit" [disabled]="!form.valid || !selectedDocument() || editDocument()">
							{{"Speichern" | translate : "action-safe"}}
						</button>
						<button mat-button type="button" (click)="cancel()">
							{{"Abbrechen" | translate : "action-cancel"}}
						</button>
					</section>
				</form>
			</app-side-menu-group-content>
		</app-side-menu-group>
		@if(editDocument()){
		<app-delete-button appInlineConfirmationTrigger #trigger="appInlineConfirmationTrigger" mat-button/>
		<app-inline-delete-confirmation [trigger]="trigger" (confirm)="_delete()"/>
		}
	</app-side-menu-content>
</app-side-menu>